module.exports = __webpack_public_path__ + "img/tt-logo.d9a8bd50.svg";